import React from 'react';
import { Image, Modal } from 'semantic-ui-react';
import DOMPurify from 'dompurify';
import { Button } from 'components/quashed';
import { getPolicyDetailsRoute } from 'helpers';
import history from 'helpers/history';
import { IPolicy, IEmployer, IEmployerPolicy } from 'types';
import styles from './styles/q4ePopup.scss';

interface IProps {
  employer: IEmployer;
  open: boolean;
  policy: IPolicy;
  employerPolicy: IEmployerPolicy;
  onClose(): void;
  updatePolicy(policy: IPolicy): void;
}

const Q4EPopup = ({
  employer,
  open,
  employerPolicy,
  policy,
  onClose,
  updatePolicy,
}: IProps) => {
  if (!employer || !employerPolicy || !policy) {
    return null;
  }

  const { note } = employerPolicy;

  const updateEmployerPolicy = () => {
    updatePolicy({
      ...policy,
      ...employerPolicy.customAttributes,
    });
    history.push(getPolicyDetailsRoute(policy.id));
  };

  return (
    <Modal className={styles.modal} open={open} onClose={onClose}>
      <Modal.Content>
        <div className={styles.imgContainer}>
          <Image avatar={true} size="tiny" src={employer.employerLogoUrl} />
        </div>
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(note) }} />
        <div className={styles.buttons}>
          <Button
            className={styles.yes}
            text="Yes, I’ve already signed up"
            onClick={updateEmployerPolicy}
          />
          <Button
            className={styles.no}
            text="No, I haven’t"
            inverted={true}
            onClick={onClose}
          />
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default Q4EPopup;
